export const STORAGE_KEYS = {
  AUTH_TOKEN: 'authToken'
};

export const API_ENDPOINTS = {
  LOGIN: '/admin-login',
  GET_PROFILE: '/admin-profile',
  GET_USER_COUNTS: '/user-counts',
  GET_USERS: '/get-all-users',
  GET_SINGLE_USER: '/get-single-user',
  GET_USER_PAYMENT_HISTORY: '/get-user-subscription-details',
  GET_ALL_USER_GIFTS: '/get-all-user-gifts',
  EXPORT_USERS: '/export-users',
  EXPORT_ORDERS: '/order/export-orders',
  EXPORT_MILESTONE_GIFTS: '/order/export-unverified-conditional-gifts',
  EXPORT_POSTHUMOUS_GIFTS: '/order/export-unverified-post-mortem-gifts',
  EXPORT_SUBSCRIPTIONS: '/subscriptions/export',
  EXPORT_SUPPORT_TICKETS: '/support/admin/export-support-tickets',
  EXPORT_TRANSACTIONS: '/transactions/export-transactions'
};

export const VALIDATION_MESSAGES = {
  REQUIRED: 'This field is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  PASSWORD_TOO_SHORT: 'Password must be at least 6 characters',
};

export const REGEX_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/
};
